import {
  HttpContext,
  HttpContextToken,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { IApiOptions } from 'src/app/core/contracts';
import { UserData } from 'src/app/data/user.data';

export const CompanyInterceptorOptions = new HttpContextToken<{ setCompanyId: boolean }>(() => {
  return { setCompanyId: false };
});

export const passCompanyId = (): IApiOptions => {
  // APIs requiring companyId parameter should spread this api options object, e.g: this.api.get('endpoint', { ...passCompanyId(), params })
  return { context: new HttpContext().set(CompanyInterceptorOptions, { setCompanyId: true }) };
};

@Injectable()
export class CompanyInterceptor implements HttpInterceptor {
  constructor(private userData: UserData) {}
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<unknown> | HttpUserEvent<unknown>> {
    if (req.context.get(CompanyInterceptorOptions).setCompanyId) {
      return this.userData.companyId$.pipe(
        first(),
        switchMap(id => {
          if (id == null) {
            return next.handle(req);
          }
          const modified = req.clone({ params: req.params.set('companyId', id) });
          return next.handle(modified);
        })
      );
    }
    return next.handle(req);
  }
}
